/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Select, message, Spin } from "antd";
import API from "../../../api";
import urls from "../../../api/urls";
import "./style.scss";
const { GET_ALL_RATE_SLABS } = urls;
const SlabSelect = ({
  head,
  value,
  onChange,
  //setRateSlabList1,
  createSlab,
  predefined,
  disable,
  userId,
  setLoder = () => {},
}) => {
  const { Option } = Select;
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [searchValue, setSearchValue] = useState("");

  const fetchSlabs = async (search = "", currentPage = 1) => {
    try {
      setLoder(true);
      let url = GET_ALL_RATE_SLABS;
      if (predefined) {
        url = `${GET_ALL_RATE_SLABS}?chargesHead=${head}&searchTerm=${search}&page=${currentPage}&userId=${userId}`;
      } else {
        url = `${GET_ALL_RATE_SLABS}?searchTerm=${search}&page=${currentPage}`;
      }
      const response = await API.Api(url).get();
      if (response?.status) {
        const data = response?.response?.data?.items;

        if (currentPage === 1) {
          let dataSlab =
            data?.map((item) => ({
              label: item?.name,
              value: item?.name,
              ...item,
            })) || [];
          setOptions(dataSlab);
          //setRateSlabList1(dataSlab);
        } else {
          setOptions((prev) => [...prev, ...(data?.data || [])]);
          //setRateSlabList1((prev) => [...prev, ...(data?.data || [])]);
        }

        setHasMore(response?.response?.data?.total > 10 || false);
      } else {
        message.error(
          response?.response?.data?.message ||
            `Error fetching slabs for ${head} slabs`
        );
      }
    } catch (error) {
      setLoder(false);
      console.error(`Error fetching slabs for ${head}:`, error);
    } finally {
      setLoder(false);
    }
  };
  useEffect(() => {
    //console.log(searchValue, page, value, "searchValue, page, value");
    fetchSlabs(searchValue, page);
  }, [searchValue, page, value]);

  const handleSearch = (value) => {
    setSearchValue(value);
    setPage(1);
  };

  const handleScroll = (event) => {
    const { target } = event;
    if (
      target.scrollTop + target.offsetHeight === target.scrollHeight &&
      hasMore &&
      !loading
    ) {
      setPage((prev) => prev + 1);
    }
  };

  return (
    <div className="d-flex" key={head}>
      <Select
        showSearch
        allowClear
        placeholder="Choose Slab"
        style={{ width: "300px" }}
        value={value}
        onSearch={handleSearch}
        onPopupScroll={handleScroll}
        notFoundContent={loading ? <Spin size="small" /> : "No options"}
        filterOption={false}
        onChange={onChange}
        disabled={disable}
      >
        {options.map((item) => (
          <Option key={item.value} value={item.value}>
            {item.label}
          </Option>
        ))}
      </Select>
      {value && (
        <>
          <a
            className="align-center ml-1"
            onClick={() => {
              createSlab(value, options, head);
            }}
          >
            View Slab
          </a>
        </>
      )}
    </div>
  );
};
export default SlabSelect;
